import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import useDynamicContent from "../hooks/useDynamicContent";

export default function ContactPage() {
  const { content } = useDynamicContent('contact');
  
  const heroEyebrow = content.hero_eyebrow || "Get in touch";
  const heroTitle = content.hero_title || "Let’s talk approvals.";
  const heroDescription = content.hero_description || "Reach us by phone, email or the form below. Our office is open Monday to Saturday, 10am – 7pm IST.";

  return (
    <main data-testid="contact-page">
      <PageHero
        eyebrow={heroEyebrow}
        title={heroTitle}
        description={heroDescription}
        breadcrumbs={["Home", "Contact"]}
      />
      <ContactSection embedded />
    </main>
  );
}
